import {
	getUsersPage,
    getUsersCount
} from '@/api/users';

import Pagination from '@/components/Pagination';
let _this;
export default {
	name: 'shares',
    components: {
		Pagination
	},
    
	data() {
		return {
			orderObj: { //订单列表
				list: [],
				total: 0,
				listLoading: false,
			},
            orderCount: { //数量
                sysNum: 0,
                sharerNum: 0
            },
            payDate: [],
			form: {
				pageNum: 1,
				pageSize: 10,
			},
            userTypeList: [{}]
		}
	},
	beforeCreate() {
        _this = this;
	},
    filters: {
    },
	created() {
		this.getOrderPage()
	},
	methods: {
		//获取订单列表
		getOrderPage() {
            if(this.payDate){
                this.form.createTimeStartYMDStr = this.payDate[0]
                this.form.createTimeEndYMDStr = this.payDate[1]
            }else{
                this.form.createTimeStartYMDStr = ''
                this.form.createTimeEndYMDStr = ''
            }
            this.orderObj.listLoading = true;
			//获取订单列表
			getUsersPage(this.form).then(res => {
				this.orderObj.list = res.data.list;
                this.orderObj.total = res.data.total;
				this.orderObj.listLoading = false;

			})

            //获取订单统计
            getUsersCount({
                telnoLike: this.form.telnoLike,
                createTimeStartYMDStr: this.form.createTimeStartYMDStr,
                createTimeEndYMDStr: this.form.createTimeEndYMDStr,
                userType: this.form.userType
            }).then(res => {
                if(res.code == 200){
                    this.orderCount.sysNum = res.data.sysNum
                    this.orderCount.sharerNum = res.data.sharerNum
                }
            });
		},
	}
}
